<div class="nfs-left-block">
  <div class="quote-project-name">
    {{quote.jobName}}
  </div>
  <div class="message-box">
    Date: {{quote.installationDate | date: 'MMM dd, yyyy'}}
  </div>
  <div class="message-box" *ngIf="quote.price > 0">
    Price: ${{quote.price}}
  </div>
</div>
